<mat-dialog-content>
  <vitamui-dialog-content-with-state state="invalid" [title]="'ERROR_DIALOG.TITLE' | translate">
    <div class="text medium bold">{{ 'ERROR_DIALOG.MESSAGE' | translate }}</div>
  </vitamui-dialog-content-with-state>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="btn primary" mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
</mat-dialog-actions>
